"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Actions, Effect, toPayload } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Auth } from '@shared/auth';
import { pluckListItemFromRawStore } from '../helpers';
var MessagesEffect = (function () {
    function MessagesEffect(actions, auth, store) {
        this.actions = actions;
        this.auth = auth;
        this.store = store;
        this.fetchData = this.actions
            .ofType('WS_MESSAGE')
            .map(toPayload)
            .filter(isMessagesPrivatePayload)
            .withLatestFrom(this.store, this.auth.authState)
            .do(function (_a) {
            var wsMessage = _a[0], state = _a[1], auth = _a[2];
            if (window.liveChat) {
                window.liveChat.startChat([], undefined, 'websocket', undefined, wsMessage.data.thread_id, false);
            }
        })
            .filter(function (_a) {
            var wsMessage = _a[0], state = _a[1], auth = _a[2];
            return !!auth &&
                !pluckListItemFromRawStore(state, ['threads', auth.userId], wsMessage.data.thread_id);
        })
            .map(function (_a) {
            var wsMessage = _a[0], state = _a[1], auth = _a[2];
            var action = {
                type: 'REQUEST_DATA',
                payload: {
                    type: 'threads',
                    refList: { pathList: ['threads', [auth.userId]] },
                    query: { params: { 'threads[]': wsMessage.data.thread_id } },
                },
            };
            return action;
        })
            .mergeMap(function (action) { return [action, { type: '_MISSING_THREAD_FETCHING_' }]; });
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], MessagesEffect.prototype, "fetchData", void 0);
    MessagesEffect = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Actions,
            Auth,
            Store])
    ], MessagesEffect);
    return MessagesEffect;
}());
export { MessagesEffect };
function isMessagesPrivatePayload(p) {
    return p.type === 'private' && p.parent_type === 'messages';
}



// WEBPACK FOOTER //
// messages.effect.js